import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LcsApiService } from '@lcs/shared/api';
import { CommonReportParameters } from '@ndt/reports/shared/models/report-parameters-base.interface';
import { Observable } from 'rxjs';
import { DashboardTileParametersPostModel } from '../models/dashboard-tile-parameters-post.model';
import { ExecuteTilePostModel } from '../models/execute-tile-post.model';

@Injectable({ providedIn: 'root' })
export class TileHttpService {
   constructor(private httpClient: HttpClient, private apiService: LcsApiService) {}

   post<T, P>(url: string, parameters: P): Observable<T> {
      return this.httpClient.post<T>(this.buildUrl(url), this.buildParameters<P>(parameters), {
         params: new HttpParams({
            fromObject: {
               SerializeEnumsAsStrings: 'true',
            },
         }),
      });
   }

   postParameters<T, P>(url: string, body: DashboardTileParametersPostModel): Observable<T> {
      return this.httpClient.post<T>(this.buildUrl(url), body, {
         params: new HttpParams({
            fromObject: {
               SerializeEnumsAsStrings: 'true',
            },
         }),
      });
   }

   private buildUrl(url: string): string {
      return this.apiService.apiUrl + url;
   }

   /**
    * Adds the `timeZone` parameter to the given parameters object.
    * Uses the browser's local time zone from the Intl API.
    * @param parameters The parameters object to extend.
    * @returns A shallow copy of the given parameters object, with the `timeZone` parameter added.
    */
   private buildParameters<P>(parameters: P): P & CommonReportParameters {
      return {
         ...parameters,
         timeZone: { value: Intl.DateTimeFormat().resolvedOptions().timeZone },
      };
   }

   appendTimeZoneTileParameter(params: ExecuteTilePostModel): ExecuteTilePostModel {
      return {
         ...params,
         parameters: {
            ...params.parameters,
            timeZone: {
               value: Intl.DateTimeFormat().resolvedOptions().timeZone,
               fields: [],
            },
            fields: [],
         },
      };
   }
}
